theme.SlideShow = (function () {
  function Slider(e) {
    let slideshow = e.querySelector(".slideshow__wrapper"),
      paginationSelector = e.querySelector(".swiper-pagination"),
      navselectorPrev = e.querySelector(".swiper-button-prev"),
      navselectorNext = e.querySelector(".swiper-button-next"),
      autoplaySelctor = e.dataset.sliderAutoplay,
      autoplayInit = false,
      autoPlayDelay = parseInt(e.dataset.sliderDelay),
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      slidePagination = e.dataset.pagination,
      paginatinInit = "bullets";

    // Guard against double initialization
    if (slideshow.swiper) {
      slideshow.swiper.destroy(true, true);
    }

    if (autoplaySelctor === "true") {
      autoplayInit = {
        delay: autoPlayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      };
    }
    if (loopSelector === "true") {
      loopInit = true;
    }

    if (slidePagination === "counter") {
      paginatinInit = "fraction";
    }

    // Detect if device supports touch
    var isTouchDevice = ('ontouchstart' in window) || 
                        (navigator.maxTouchPoints > 0) || 
                        (navigator.msMaxTouchPoints > 0);
    
    var swiper = new Swiper(slideshow, {
      loop: loopInit,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      autoplay: autoplayInit,
      autoHeight: false,
      speed: 500,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      // Enable smooth mouse drag on desktop
      simulateTouch: true,
      grabCursor: true,
      // Fix for Android Chrome double-advance issue on touch devices
      // On desktop, prevent default to avoid sticky drag behavior
      touchStartPreventDefault: !isTouchDevice,
      threshold: 10,
      longSwipesRatio: 0.3,
      // Prevent loop mode from creating extra slides that cause jumps
      loopAdditionalSlides: 0,
    });

    // Stop autoplay when user interacts with navigation
    if (autoplayInit) {
      navselectorPrev.addEventListener("click", function () {
        swiper.autoplay.stop();
      });
      navselectorNext.addEventListener("click", function () {
        swiper.autoplay.stop();
      });
    }
  }
  return Slider;
})();
